import { motion, useReducedMotion } from 'framer-motion'

// Step 4 — the CASH OUT action (success colour) + Auto Cashout target. Shared.
const CashoutVisual = () => {
  const reduce = useReducedMotion()

  return (
    <div className="htp-actions">
      <motion.div
        className="htp-cta is-cash"
        animate={reduce ? undefined : { scale: [1, 1.04, 1] }}
        transition={reduce ? undefined : { repeat: Infinity, duration: 1.6, ease: 'easeInOut' }}
      >
        <span>CASH OUT · 248.00</span>
        <small>@ 2.48×</small>
      </motion.div>
      <div className="htp-pill">
        <span>Auto Cashout</span>
        <b>3.00×</b>
      </div>
    </div>
  )
}

export default CashoutVisual
